import { useTranslation } from 'react-i18next'

const useTourReservation = () => {
  const { t } = useTranslation('tour')
  return [
    {
      selector: '.joyride-tourReservation-buyerDataCustomerSelect',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.reservation.clientNameInput')}
          </p>
          <span>{t('tour.reservation.clientNameInputDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourReservation-buyerDataTourismTaxCheckbox',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.reservation.allowTurismTaxCheckbox')}
          </p>
          <span>{t('tour.reservation.allowTurismTaxCheckboxDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourReservation-buyerDataNoShowGuaranteeCheckbox',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.reservation.noShowGuaranteeCheckbox')}
          </p>
          <span>
            {t('tour.reservation.noShowGuaranteeCheckboxDescription')}
          </span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourReservation-guestInformationFirstNameInput',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.reservation.guestName')}
          </p>
          <span>{t('tour.reservation.guestNameDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourReservation-guestInformationLastNameInput',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.reservation.guestLastName')}
          </p>
          <span>{t('tour.reservation.guestLastNameDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourReservation-guestInformationEmail',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.reservation.guestEmail')}
          </p>
          <span>{t('tour.reservation.guestEmailDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourReservation-billingPaymentMethodSelect',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.reservation.paymentMethod')}
          </p>
          <span>{t('tour.reservation.paymentMethodDescription')}</span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourReservation-billingAuthorizedExpenses',
      content: (
        <div>
          <p className="text-primary font-bold">
            {t('tour.reservation.guestAuthorizedExpenses')}
          </p>
          <span>
            {t('tour.reservation.guestAuthorizedExpensesDescription')}
          </span>
        </div>
      ),
    },
    {
      selector: '.joyride-tourReservation-billingObservations',
      content: (
        <div>
          <p className="text-primary font-bold">{t('tour.vipModal')}</p>
          <span>{t('tour.reservation.guestObservation')}</span>
          <div>{t('tour.reservation.guestObservationDescription')}</div>
        </div>
      ),
    },
  ]
}

export default useTourReservation
